import {
    BaseError,
} from 'wanderu-utils';

export class SnowplowSdkFailedToLoad extends BaseError {
    constructor() {
        super('Snowplow\'s SDK failed load');
    }
}

// eslint-disable-next-line sort-exports/sort-exports
export class SnowplowNotInitialized extends BaseError {
    constructor() {
        super('Snowplow\'s SDK is not initialized');
    }
}
